"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertQueueCache = void 0;
const expert_queue_api_types_1 = require("@soluto-private/expert-queue-api-types");
class ExpertQueueCache {
    constructor(expertId) {
        this._expertQueueCache = {
            expertId,
            items: {},
        };
    }
    update(update) {
        if (this._expertQueueCache.expertId !== update.expertId) {
            return this._expertQueueCache;
        }
        switch (update.eventType) {
            case expert_queue_api_types_1.ExpertQueueEventType.refresh:
                this._expertQueueCache = update.value;
                break;
            case expert_queue_api_types_1.ExpertQueueEventType.upsert:
                if (!this._expertQueueCache.items[update.value.sessionId]) {
                    this._expertQueueCache.items[update.value.sessionId] = Object.assign(Object.assign({}, update.value), { attributes: [] });
                    break;
                }
                Object.assign(this._expertQueueCache.items[update.value.sessionId], update.value);
                break;
            case expert_queue_api_types_1.ExpertQueueEventType.attributeChanged:
                this._expertQueueCache.items[update.value.sessionId] = update.value;
                break;
            case expert_queue_api_types_1.ExpertQueueEventType.remove:
                delete this._expertQueueCache.items[update.value.sessionId];
                break;
        }
        return this._expertQueueCache;
    }
}
exports.ExpertQueueCache = ExpertQueueCache;
